import ActionType from './ActionType'
import API_URL from 'utils/ApiUrl'

let schemas = ['signupform', 'task']

export const loadCreateSchemas = (argObject = {}) => (dispatch, getState) => {
  dispatch({
    type: ActionType.Schemas.LOAD_CREATE_SCHEMAS_REQUESTS,
    ...argObject,
  })
  // map every url to the promise of the fetch
  let requests = schemas.map(schema =>
    fetch(`${API_URL}/schema/${schema}/POST/request`)
      .then(res => res.json())
      .then(schemaRes => ({ ...schemaRes, type: schema })),
  )

  // Promise.all waits until all jobs are resolved
  return Promise.all(requests)
    .then(allCreateSchemas =>
      dispatch({
        type: ActionType.Schemas.LOAD_CREATE_SCHEMAS_SUCCESS,
        payload: allCreateSchemas,
        ...argObject,
      }),
    )
    .catch(error =>
      dispatch({ type: ActionType.Schemas.LOAD_CREATE_SCHEMAS_FAILURE, error }),
    )
}
